import styled, { css } from 'styled-components';
import TemplateFetcher from '../app/components/TemplateFetcher';

export const ModalTemplateFetcher = styled(TemplateFetcher)<{ absolutePosition: boolean }>`
    ${(props) =>
        props.absolutePosition &&
        css`
            @media not print {
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                left: 0;
                overflow: hidden;
            }
        `}

    display: flex;
    flex-flow: column;
    height: 100%;

    & > div {
        flex: 0 0 auto;

        &.modal-body {
            flex: 1 1 auto;
            overflow-y: auto;
            overflow-x: hidden;
            position: relative;
        }
    }
`;
ModalTemplateFetcher.displayName = 'ModalTemplateFetcher';
